module.exports = __webpack_public_path__ + "img/DSC_0108.a1075862.jpg";